import {Tabs} from "antd";
import {useTranslation} from "react-i18next";
import AccountVerify_2 from "./component/accountVerify";
import "./css/style.css"
import VerificationHistory_2 from "./component/verificationHistory";
import {useState} from "react";

export default function AccountVerificationV2_2(props) {
    const { t } = useTranslation();
    const { deepLinkTab, deepLinkId } = props;
    const [currentTab, setCurrentTab] = useState(deepLinkTab === 'uploadHistory' ? 'uploadHistory' : 'accountVerification');

    const tabItems = [
        {
            key: "accountVerification",
            label: t("accountVerification.accountVerification"),
            children: (
                <AccountVerify_2
                    {...props}
                />
            )
        },
        {
            key: "uploadHistory",
            label: t("accountVerification.uploadHistory"),
            children: (
                <VerificationHistory_2 {...props} currentTab={currentTab} deepLinkId={deepLinkId}/>
            ),
        },
    ]

    return (
        <div id={"accountVerificationV2"}>
            <Tabs
                activeKey={currentTab}
                items={tabItems}
                className={"tabColour"}
                onChange={(key) => setCurrentTab(key)}
            />
        </div>
    )
}